<template>
    <c-dialog ref="dialog" title="用户协议详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <div class="m-detail-box">
            <c-title>基本信息</c-title>
            <c-detail column="2">
                <c-detail-item label="协议代码">
                    {{detailData.agreement_code}}
                </c-detail-item>
                <c-detail-item label="协议名称">
                    {{detailData.agreement_name}}
                </c-detail-item>
                <c-detail-item label="创建人">
                    {{detailData.create_user_realname}}
                </c-detail-item>
                <c-detail-item label="创建时间">
                    {{detailData.create_date}}
                </c-detail-item>
                <c-detail-item label="更新人">
                    {{detailData.update_user_realname}}
                </c-detail-item>
                <c-detail-item label="更新时间">
                    {{detailData.update_date}}
                </c-detail-item>
            </c-detail>

            <c-title>协议内容</c-title>
            <div class="agreement-content" v-html="detailData.content"></div>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'legalAgreementDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.request({
                url: '/legal_agreement/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data;
                    this.$refs.dialog.open();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>.m-detail-box {
    display: flex;
    flex-direction: column;
    max-height: 90%;

    >>> .c-title {
        flex-shrink: 0;
    }

    >>> c-detail {
        flex-shrink: 0;
    }
}

.agreement-content {
    padding: 15px;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    line-height: 1.6;
    font-family: "Microsoft YaHei", sans-serif;
    color: #333;
    overflow-y: auto;
    max-height: 70%;

    >>> h1 {
        text-align: center;
        color: #2c3e50;
        margin-bottom: 30px;
        font-size: 20px;
    }

    >>> h2 {
        color: #34495e;
        margin: 25px 0 15px;
        font-size: 18px;
        border-left: 3px solid #3498db;
        padding-left: 10px;
    }

    >>> h3 {
        color: #4a69bd;
        margin: 20px 0 10px;
        font-size: 16px;
    }

    >>> p {
        margin: 10px 0;
        font-size: 14px;
    }

    >>> ul {
        margin: 10px 0 10px 20px;
        padding: 0;
    }

    >>> li {
        margin: 5px 0;
        font-size: 14px;
    }

    >>> * {
        max-width: 100%;
    }

    >>> img {
        max-width: 100%;
        height: auto;
    }
}
</style>